import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import logo from "../../../assets/images/logo.jpeg";
// accreditation, footerImg, footerImgg logo imports removed — were only used by the
// commented-out Accreditations column below; re-add from ../../../assets/images/
// (Accreditation-logo.jpg, footerImg.jpg, footerImg1.jpg) if that section comes back.

export default function ArdrendFooter() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0b0f19] pt-0 relative border-t border-gray-100">

      {/* Massive CTA Section */}
      <div className="bg-primary pt-24 pb-20 relative overflow-hidden">
        <div className="max-w-[1560px] mx-auto px-6 relative z-10 flex flex-col md:flex-row items-center justify-between gap-10">
          <div>
            <h2 className="text-white text-4xl md:text-6xl font-black mb-4 tracking-tight leading-tight">{t("footer.ctaTitle")}</h2>
            <p className="text-white/80 text-xl font-medium max-w-xl">{t("footer.ctaText")}</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 shrink-0">
            <Link to="/courses" className="bg-white text-[#0b0f19] hover:bg-gray-100 font-bold text-lg px-10 py-5 flex items-center justify-center transition-all duration-300">
              {t("footer.exploreCourses")}
            </Link>
            <Link to="/contact" className="bg-transparent border border-white/30 text-white hover:bg-white/10 font-bold text-lg px-10 py-5 flex items-center justify-center transition-all duration-300">
              {t("footer.speakToAdvisor")}
            </Link>
          </div>
        </div>
        {/* Background graphic */}
        <svg className="absolute -top-24 -right-24 w-96 h-96 text-white/5 transform rotate-12" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
        </svg>
      </div>

      {/* Main Footer Content */}
      <div className="max-w-[1560px] mx-auto px-6 pt-24 pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-20">

          {/* Brand Col */}
          <div className="lg:col-span-4 flex flex-col pr-8">
            <Link to="/" className="inline-block mb-6">
              <img src={logo} alt="E1X Academy" className="h-16 w-auto object-contain" />
            </Link>
            <p className="text-gray-400 text-lg leading-relaxed mb-8 font-light">
              {t("footer.brandBlurb")}
            </p>
            <div className="flex gap-4">
              <a href="/" className="w-12 h-12 border border-gray-800 flex items-center justify-center hover:bg-primary hover:border-primary transition-all duration-300 text-white group">
                <svg fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 group-hover:scale-110 transition-transform"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/></svg>
              </a>
              <a href="/" className="w-12 h-12 border border-gray-800 flex items-center justify-center hover:bg-primary hover:border-primary transition-all duration-300 text-white group">
                <svg fill="currentColor" viewBox="0 0 24 24" className="w-5 h-5 group-hover:scale-110 transition-transform"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold text-sm mb-8 tracking-widest uppercase flex items-center gap-3">
              <span className="w-4 h-px bg-primary"></span>
              {t("footer.platform")}
            </h4>
            <ul className="flex flex-col gap-5">
              <li><Link to="/courses" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.bootcamps")}</Link></li>
              <li><Link to="/scholarships" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.scholarships")}</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.aboutUs")}</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.contact")}</Link></li>
            </ul>
          </div>

          {/* Hub */}
          <div className="lg:col-span-2">
            <h4 className="text-white font-bold text-sm mb-8 tracking-widest uppercase flex items-center gap-3">
              <span className="w-4 h-px bg-primary"></span>
              {t("footer.resources")}
            </h4>
            <ul className="flex flex-col gap-5">
              <li><Link to="/blog" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.insights")}</Link></li>
              <li><Link to="/webinars-events" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.events")}</Link></li>
              <li><Link to="/faq" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.faq")}</Link></li>
              <li><Link to="/talents" className="text-gray-400 hover:text-white transition-colors text-base font-medium">{t("footer.hireTalent")}</Link></li>
            </ul>
          </div>

          {/* Accreditations — commented out until accreditation claims are confirmed; see Get in Touch below for the temporary replacement
          <div className="lg:col-span-4 flex flex-col gap-6">
            <h4 className="text-white font-bold text-sm mb-4 tracking-widest uppercase flex items-center gap-3">
              <span className="w-4 h-px bg-primary"></span>
              Accreditations
            </h4>
            <div className="grid grid-cols-1 gap-4">
              <div className="flex items-center gap-5 border border-gray-800 p-4 hover:border-gray-600 transition-colors bg-gray-900/50">
                <img src={accreditation} alt="ACTD" className="w-12 h-12 object-contain bg-white p-1 shrink-0" />
                <p className="text-gray-400 text-sm leading-snug">Accredited by the American Council of Training and Development.</p>
              </div>
              <div className="flex items-center gap-5 border border-gray-800 p-4 hover:border-gray-600 transition-colors bg-gray-900/50">
                <img src={footerImg} alt="AAPM" className="w-12 h-12 object-contain bg-white p-1 shrink-0" />
                <p className="text-gray-400 text-sm leading-snug">Certified by the American Academy of Project Management.</p>
              </div>
              <div className="flex items-center gap-5 border border-gray-800 p-4 hover:border-gray-600 transition-colors bg-gray-900/50">
                <img src={footerImgg} alt="ERMA" className="w-12 h-12 object-contain bg-white p-1 shrink-0" />
                <p className="text-gray-400 text-sm leading-snug">Certified by the Enterprise Risk Management Academy.</p>
              </div>
            </div>
          </div>
          */}

          {/* Get in Touch — temporary stand-in for the Accreditations column above */}
          <div className="lg:col-span-4 flex flex-col gap-6">
            <h4 className="text-white font-bold text-sm mb-4 tracking-widest uppercase flex items-center gap-3">
              <span className="w-4 h-px bg-primary"></span>
              {t("footer.getInTouch")}
            </h4>
            <ul className="flex flex-col gap-5">
              <li className="text-gray-400 text-base font-medium leading-relaxed">{t("footer.address")}</li>
              <li><a href="tel:+12029339591" className="text-gray-400 hover:text-white transition-colors text-base font-medium">+1 (202) 933-9591</a></li>
              <li><a href="mailto:info@e1xacademy.net" className="text-gray-400 hover:text-white transition-colors text-base font-medium">info@e1xacademy.net</a></li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-gray-500 text-sm font-medium">
            {t("footer.copyright", { year: currentYear })}
          </p>
          <div className="flex items-center gap-8">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-white text-sm font-medium transition-colors">{t("footer.privacyPolicy")}</Link>
            <Link to="/terms" className="text-gray-500 hover:text-white text-sm font-medium transition-colors">{t("footer.termsOfService")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
